import { render, staticRenderFns } from "./bell.vue?vue&type=template&id=b347a6ca&scoped=true&"
import script from "./bell.vue?vue&type=script&lang=js&"
export * from "./bell.vue?vue&type=script&lang=js&"
import style0 from "./bell.vue?vue&type=style&index=0&id=b347a6ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b347a6ca",
  null
  
)

export default component.exports